import React, { useState } from "react";
import useAuth from "../../../hooks/useAuth";
import { closeBackdrop } from "../../../slice/sellerHub/sellerhubSlice";
import Button from "../buttons/Button";
import { useDispatch } from "react-redux";
import Overview from "./Overview";
import History from "./History";
import Transaction from "./Transaction";

const InventoryIndividual = () => {
  const { inventoryIndividual } = useAuth();
  const [inview, setInview] = useState("overview");
  const dispatch = useDispatch();
  return (
    <div className="w-full md:w-[500px] lg:w-[806px] h-full bg-white p-5">
      <div className="flex gap-5 md:gap-0 justify-between flex-col md:flex-row items-start md:items-center">
        <h4>Item ID: {inventoryIndividual[0].itemId}</h4>
        <div className="w-full md:w-auto flex justify-end md:justify-start gap-10 items-center">
          <div
            className="w-fit text-logoRed font-Inter font-medium cursor-pointer"
            onClick={() => dispatch(closeBackdrop())}
          >
            Close
          </div>
          <Button
            innerText="Download"
            width="w-[133px]"
            icon={[
              <svg
                key={Math.random()}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-file-earmark-minus"
                viewBox="0 0 16 16"
              >
                <path d="M5.5 9a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z" />
                <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
              </svg>,
            ]}
          />
        </div>
      </div>

      <div className="flex gap-8 mt-5 items-center border-b-2 border-[#F4F4F4]">
        <button
          className={`${
            inview === "overview"
              ? "text-sidenavActive border-b-2 border-sidenavActive"
              : "text-black border-none"
          } pb-2`}
          onClick={() => setInview("overview")}
        >
          Overview
        </button>
        <button
          className={`${
            inview === "history"
              ? "text-sidenavActive border-b-2 border-sidenavActive"
              : "text-black border-none"
          } pb-2`}
          onClick={() => setInview("history")}
        >
          History
        </button>
        <button
          className={`${
            inview === "transaction"
              ? "text-sidenavActive border-b-2 border-sidenavActive"
              : "text-black border-none"
          } pb-2`}
          onClick={() => setInview("transaction")}
        >
          Transaction
        </button>
      </div>

      {inview === "overview" ? (
        <Overview />
      ) : inview === "history" ? (
        <History />
      ) : (
        <Transaction />
      )}
    </div>
  );
};

export default InventoryIndividual;
